module.exports = __webpack_public_path__ + "static/media/p1a6.52c086fb.wav";